"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDesktopSize = getDesktopSize;
exports.getWindowSize = getWindowSize;
function getDesktopSize(window) {
  var width = window.screen && window.screen.width || 0;
  var height = window.screen && window.screen.height || 0;

  return width + "x" + height;
}

function getWindowSize(window) {
  var width = 0;
  var height = 0;

  if (window.innerWidth) {
    width = window.innerWidth;
    height = window.innerHeight;
  } else if (window.document) {
    if (window.document.documentElement && window.document.documentElement.clientWidth) {
      width = window.document.documentElement.clientWidth;
      height = window.document.documentElement.clientHeight;
    } else if (window.document.body && window.document.body.clientWidth) {
      width = window.document.body.clientWidth;
      height = window.document.body.clientHeight;
    }
  }

  return width + "x" + height;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/web-bi-logger/dist/src/lib/screen.js
// module id = 159
// module chunks = 0